(ns teamoesterreich.admin-mode.event.detail.event-detail-form
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.component.org-selector :as org-selector]
            [teamoesterreich.admin-mode.modal.create-with-name-modal :as create-with-name-modal]
            [reagent.core :as r]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.view-state :as store]
            [teamoesterreich.admin-mode.ui-helper.editable-markdown-card :as edit-md-card]
            [teamoesterreich.admin-mode.ui-helper.sms-block-edit-card :as sms-block-edit-card]

            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.data.event :as d-events]

            [reagent-material-ui.icons.file-copy :refer [file-copy]]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.send :refer [send]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.markdown :refer [md]]))








(defn get-base [!actual-event !event-detail-loaded? disabled]
  (let [!st (r/atom {:edit-mode false :data {} :copy-modal false})
        !copy-modal (r/cursor !st [:copy-modal])
        !edit-mode (r/cursor !st [:edit-mode])
        !ws-update-lock (r/cursor store/app-state [:ws-update-lock])
        set-edit-mode-fn (fn [b] (reset! !ws-update-lock b) (reset! !edit-mode b))
        !data (r/cursor !st [:data])
        !orgId (r/cursor !st [:data :crowdtaskerEvent-orgId])]
    (fn []
      (let [has-edit-right false
            changed? (fn [key & [as_str?]]
                       ;(log/debug "changed?" key (exists? (get @!data key)) (not= (get @!data key) (get @!actual-event key)))
                       (and (exists? (get @!data key))
                            (if as_str?
                              (not= (str (get @!data key)) (str (get @!actual-event key)))
                              (not= (get @!data key) (get @!actual-event key)))))
            has-changes? (or
                           (changed? :crowdtaskerEvent-name)
                           (changed? :crowdtaskerEvent-locationName)
                           (changed? :crowdtaskerEvent-acceptableUntil)
                           (changed? :crowdtaskerEvent-timeFrom)
                           (changed? :crowdtaskerEvent-timeTo)
                           (changed? :crowdtaskerEvent-orgId)
                           (changed? :crowdtaskerEvent-hasSlots)
                           (changed? :crowdtaskerEvent-descriptionBring)
                           (changed? :crowdtaskerEvent-descriptionContact)
                           (changed? :crowdtaskerEvent-descriptionPickup)
                           (changed? :crowdtaskerEvent-descriptionTask)
                           (changed? :crowdtaskerEvent-maxMember true)
                           (changed? :crowdtaskerEvent-allowWaitingList)
                           (changed? :crowdtaskerEvent-public)
                           )
            change-fn (fn [key value] (swap! !data assoc key value))
            acceptableUntil-date (h-date/parse-service-date! (or (:crowdtaskerEvent-acceptableUntil @!data) (:crowdtaskerEvent-acceptableUntil @!actual-event)))
            from-date (h-date/parse-service-date! (or (:crowdtaskerEvent-timeFrom @!data) (:crowdtaskerEvent-timeFrom @!actual-event)))
            to-date (h-date/parse-service-date! (or (:crowdtaskerEvent-timeTo @!data) (:crowdtaskerEvent-timeTo @!actual-event)))

            fromError (and from-date to-date (h-date/date>? from-date to-date))
            acceptableError (and acceptableUntil-date to-date (or (h-date/date>? acceptableUntil-date to-date)))
            toError (and from-date to-date (or (h-date/date>? from-date to-date)))

            ]

        (when (nil? @!orgId) (reset! !orgId (:crowdtaskerEvent-orgId @!actual-event)))

        [mui/card
         (log/debug "rerender form " (clj->js @!data))
         [mui/card-header {:title "Einsatz Details"}]
         ;[mui/card-content [:span "test date " (h-date/parse-local-date (:crowdtaskerEvent-acceptableUntil @!actual-event))]]
         [mui/card-content
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "flex-start"
            :alignItems "flex-start"
            :spacing    3
            :style      {:margin "0"}
            }

           [mui/grid
            {:item  true
             :xl    6
             :md    12
             :xs    12
             :style {:backgroundColor (if (changed? :crowdtaskerEvent-orgId) "#ffd6d2" "#ffffff") :padding-left "-10px"}
             }
            [(org-selector/get-org-selector !orgId
                                            (d-rights/get-rights-orgId-filter d-rights/CLASSIC)
                                            {:longRow 1 :border "" :readonly (not @!edit-mode)})]
            ]

           [mui/grid
            {:item true
             :xl   6
             :md   12
             :xs   12
             }]

           [mui/grid
            {:container false :item true
             :xl        3
             :md        5
             :xs        12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :crowdtaskerEvent-name) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:crowdtaskerEvent-name @!actual-event))
                             :onChange     (fn [e] (change-fn :crowdtaskerEvent-name (h/event-value e)))
                             :label        "Einsatz Name"}]
            ]

           ;[mui/grid
           ; {:container false :item true
           ;  :xl        2
           ;  :md        4
           ;  :xs        12
           ;  :style     {:padding "5px"}
           ;  }
           ; [mui/text-field {
           ;                  :style        {:backgroundColor (if (changed? :crowdtaskerEvent-name) "#ffd6d2" "#ffffff")}
           ;                  :fullWidth    true
           ;                  :disabled     (not @!edit-mode)
           ;                  :defaultValue (str (:crowdtaskerEvent-category @!actual-event))
           ;                  :onChange     (fn [e] (change-fn :crowdtaskerEvent-name (h/event-value e)))
           ;                  :label        "Einsatz Art"}]
           ; ]
           [mui/grid
            {:container false :item true
             :xl        1
             :md        3
             :xs        12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :crowdtaskerEvent-locationName) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:crowdtaskerEvent-locationName @!actual-event))
                             :onChange     (fn [e] (change-fn :crowdtaskerEvent-locationName (h/event-value e)))
                             :label        "Einsatz Ort"}]
            ]

           [mui/grid
            {:container false :item true
             :xl        3
             :md        3                                   ;medium: 960px
             :xs        12
             }
            [mui/form-control-label
             {:style     {:paddingLeft "16px" :paddingRight "16px" :backgroundColor (if (changed? :crowdtaskerEvent-public) "#ffd6d2" "#ffffff")}
              :label     "Öffentlich (ohne Anmeldung sichtbar)"
              :fullWidth true
              :control   (r/as-element [mui/switch {:variant  "contained"
                                                    :checked  (or (if (nil? (:crowdtaskerEvent-public @!data)) (:crowdtaskerEvent-public @!actual-event) (:crowdtaskerEvent-public @!data)) false)
                                                    :onChange (fn [e b]
                                                                (println ":crowdtaskerEvent-public" (if b true false))
                                                                (change-fn :crowdtaskerEvent-public (if b true false)))
                                                    :disabled (not @!edit-mode)
                                                    }])}
             ]
            ]

           [mui/grid                                        ;; spacer
            {:container false :item true
             :xl        12
             :md        0
             :xs        0
             }]

           [mui/grid
            {:container false :item true
             :xl        1
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }

            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :crowdtaskerEvent-acceptableUntil) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :autoOk          true
                             :label           "Anmelde Ende"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (h/to-timezone-iso date)]
                                                  (change-fn :crowdtaskerEvent-acceptableUntil date)))
                             :defaultValue    (h/from-timezone-iso (:crowdtaskerEvent-acceptableUntil @!actual-event))
                             :error           (if acceptableError true false)
                             :helperText      (if acceptableError "ungültig (muss vor Einsatz Ende)" "")

                             }]
            ]
           [mui/grid
            {:container false :item true
             :xl        1
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :crowdtaskerEvent-timeFrom) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :autoOk          true
                             :label           "Einsatz Begin"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (h/to-timezone-iso date)]
                                                  (change-fn :crowdtaskerEvent-timeFrom date)))
                             :defaultValue    (h/from-timezone-iso (:crowdtaskerEvent-timeFrom @!actual-event))
                             :error           fromError
                             :helperText      (if fromError "ungültig (muss vor Einsatz Ende sein)" "")
                             }]
            ]
           [mui/grid
            {:container false :item true
             :xl        1
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :crowdtaskerEvent-timeTo) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :autoOk          true
                             :label           "Einsatz Ende"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (h/to-timezone-iso date)]
                                                  (change-fn :crowdtaskerEvent-timeTo date)))
                             :defaultValue    (h/from-timezone-iso (:crowdtaskerEvent-timeTo @!actual-event))
                             :error           toError
                             :helperText      (if toError "ungültig (muss nach Einsatz Beginn & in der Zukunft sein)" "")
                             ;:InputProps {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [cake]])}
                             }]
            ]


           [mui/grid                                        ;; spacer
            {:container false :item true
             :xl        12
             :md        0
             :xs        0
             :style     {:height "3px"}
             }]

           [mui/grid
            {:container false :item true
             :xl        1
             :md        3                                   ;medium: 960px
             :xs        12
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :crowdtaskerEvent-maxMember) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :type         "number"
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (get @!actual-event :crowdtaskerEvent-maxMember))
                             :onChange     (fn [e] (change-fn :crowdtaskerEvent-maxMember (h/event-value e)))
                             :label        "Max Teilnehmer"}]]

           [mui/grid
            {:container false :item true
             :xl        3
             :md        3                                   ;medium: 960px
             :xs        12
             }
            [mui/form-control-label
             {:style     {:paddingLeft "16px" :paddingRight "16px" :backgroundColor (if (changed? :crowdtaskerEvent-allowWaitingList) "#ffd6d2" "#ffffff")}
              :label     "Warteliste erlauben (deaktiviert)"
              :fullWidth true
              :control   (r/as-element [mui/switch {:variant  "contained"
                                                    :checked  (:crowdtaskerEvent-allowWaitingList @!actual-event false)
                                                    :disabled true ;(not @!edit-mode)
                                                    :onChange (fn [_ b]
                                                                (println "change-fn :crowdtaskerEvent-allowWaitingList " b)
                                                                (change-fn :crowdtaskerEvent-allowWaitingList (if b true false)))
                                                    }])}
             ]
            ]


           [mui/grid                                        ;; spacer
            {:container false :item true
             :xl        12
             :md        0
             :xs        0
             }]

           [mui/grid
            {:container false :item true
             :xl        3
             :md        6                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }

            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :crowdtaskerEvent-descriptionTask) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :multiline    true
                             :rowsMax      5
                             :minRows      2
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:crowdtaskerEvent-descriptionTask @!actual-event))
                             :onChange     (fn [e] (change-fn :crowdtaskerEvent-descriptionTask (h/event-value e)))
                             :label        "Tätigkeit"}]
            ]

           [mui/grid
            {:container false :item true
             :xl        3
             :md        6                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }

            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :crowdtaskerEvent-descriptionBring) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :multiline    true
                             :rowsMax      5
                             :minRows      2
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:crowdtaskerEvent-descriptionBring @!actual-event))
                             :onChange     (fn [e] (change-fn :crowdtaskerEvent-descriptionBring (h/event-value e)))
                             :label        "Mitzubringen"}]
            ]

           [mui/grid                                        ;; spacer
            {:container false :item true
             :xl        12
             :md        0
             :xs        0
             }]


           [mui/grid
            {:container false :item true
             :xl        3
             :md        6                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }

            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :crowdtaskerEvent-descriptionContact) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :multiline    true
                             :rowsMax      5
                             :minRows      2

                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:crowdtaskerEvent-descriptionContact @!actual-event))
                             :onChange     (fn [e] (change-fn :crowdtaskerEvent-descriptionContact (h/event-value e)))
                             :label        "Kontaktdaten (nach Annahme angezeigt)"}]
            ]

           [mui/grid
            {:container false :item true
             :xl        3
             :md        6                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }

            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :crowdtaskerEvent-descriptionPickup) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :multiline    true
                             :rowsMax      5
                             :minRows      2
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:crowdtaskerEvent-descriptionPickup @!actual-event))
                             :onChange     (fn [e] (change-fn :crowdtaskerEvent-descriptionPickup (h/event-value e)))
                             :label        "Treffpunkt  (nach Annahme angezeigt)"}]
            ]


           [mui/grid                                        ;; spacer
            {:container false :item true
             :xl        12
             :md        0
             :xs        0
             }]


           [mui/grid
            {:container false :item true
             :md        6                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }
            [create-with-name-modal/modal
             !copy-modal
             "Bitte gib einen Namen für die Einsatzkopie ein"
             "Kopieren"
             (fn [name]
               (log/debug "Create news with Name: " name)
               (d-events/>event-copy (:crowdtaskerEvent-uuid @!actual-event) name (fn []))
               )
             nil
             (str (:crowdtaskerEvent-name @!actual-event) " neu")
             ]

            [mui/card-actions
             (when (and (not @!edit-mode) (not disabled))
               [mui/button {
                            :variant   "contained"
                            :startIcon (r/as-element [edit])
                            :onClick   #(set-edit-mode-fn true)
                            } "Bearbeiten"])
             (when (and (not @!edit-mode) (d-rights/allow-admin-for d-rights/CLASSIC (:crowdtaskerEvent-orgId @!actual-event)))
               [mui/button {
                            :variant   "contained"
                            :startIcon (r/as-element [file-copy])
                            :onClick   #(reset! !copy-modal true)
                            } "Einsatz kopieren"])

             (when (and (not @!edit-mode) disabled (d-rights/allow-admin-for d-rights/CLASSIC_ACTIVATE (:crowdtaskerEvent-orgId @!actual-event)))
               [mui/button {
                            :variant   "outlined"
                            :style     {:color "orange"}
                            :startIcon (r/as-element [edit])
                            :onClick   #(set-edit-mode-fn true)
                            } "Bearbeiten (superuser)"])

             (when (and @!edit-mode)
               [mui/button {
                            :variant   "contained"
                            :startIcon (r/as-element [keyboard-arrow-left])
                            :onClick   #(set-edit-mode-fn false)
                            } "Abbrechen"])

             (when (and @!edit-mode)
               [mui/button {
                            :variant   "contained"
                            :color     "primary"
                            :startIcon (r/as-element [save])
                            :disabled  (or (not has-changes?) fromError toError acceptableError)
                            :onClick   (fn []
                                         (d-events/>event-save (:crowdtaskerEvent-uuid @!actual-event)
                                                               (merge @!data
                                                                      [:crowdtaskerEvent-orgId (if (and @!orgId (not= "" @!orgId)) @!orgId (first (d-rights/get-rights-orgId-filter d-rights/CLASSIC)))])
                                                               (fn [data]
                                                                 (reset! !actual-event data))))
                            } "Speichern"])

             ]]
           ]]

         ]))))

(defn get-alarmMessage [!actual-event !event-detail-loaded? disabled] ;; push/SMS
  (let [!st (r/atom {:show-send-me false})
        !actual-user (r/cursor store/app-state [:actual-user])
        !user-devices (r/cursor store/app-state [:user-devices])
        !show-send-me-push (r/cursor !st [:show-send-me-push])
        !show-send-me (r/cursor !st [:show-send-me])
        !su-edit (r/cursor !st [:su-edit])
        ]
    (fn []
      (log/debug "user PUSH" @!user-devices)
      (let [save-fn (fn [text]
                      (d-events/>event-save (:crowdtaskerEvent-uuid @!actual-event) {:crowdtaskerEvent-message text}
                                            (fn [data]
                                              (reset! !actual-event data)
                                              (reset! !event-detail-loaded? nil)
                                              )))
            on-cancel-fn #(reset! !su-edit false)]
        [:div
         [are-you-sure-modal/are-you-sure-modal !show-send-me-push
          "Möchtest du diesen Anfrage-Push testweise an dich senden ?" "Senden"
          (fn [] (d-events/>event-send-test-push (:crowdtaskerEvent-uuid @!actual-event) (:tom-id @!actual-user)))]
         [are-you-sure-modal/are-you-sure-modal !show-send-me
          "Möchtest du diese Anfrage-SMS testweise an dich senden ?" "Senden"
          (fn [] (d-events/>event-send-test-alarm (:crowdtaskerEvent-uuid @!actual-event) (:tom-id @!actual-user)))]

         (if (and (not (true? @!su-edit)) disabled)
           [:div {:style {:border "1px dotted darkgrey" :paddingBottom "10px"}}
            [:h3 "Einsatzanfrage (SMS/Push)"]
            [:div {:style {:border "1px dotted black" :width "100%" :min-height "20px" :max-width "800px" :margin "5px auto 5px auto "}} (get @!actual-event :crowdtaskerEvent-message)]
            (when (d-rights/allow-admin-for d-rights/CLASSIC_ACTIVATE (:crowdtaskerEvent-orgId @!actual-event))
              [mui/button {
                           :variant   "outlined"
                           :style     {:color "orange"}
                           :startIcon (r/as-element [edit])
                           :onClick   #(reset! !su-edit true)
                           } "Bearbeiten (superuser)"])]
           [:div
            [mui/card-header {:title "Alte Einsatzanfrage über SMS/Push (nur für eingeladen Teilnehmer)"}]
            [(sms-block-edit-card/get-it (get @!actual-event :crowdtaskerEvent-message)
                                         save-fn
                                         {:titel              "Einsatzanfrage (SMS/Push)"
                                          :template-group     "event"
                                          :subText            (r/as-element
                                                                [:p
                                                                 "Muss beinhalten: `" (txt/txt :core "Team") "` und JA/Nein für Zu/Absage"
                                                                 [:br]
                                                                 "Textblöcke: #TOMID#,#VORNAME#,#NACHNAME#,#PREMAIL#,#PRHDY#,#PRHDY0#,#DIENSTSTELLE#, #ESTYP#,#KURZ#,#EVKURZ#,#ORT#,#BEGINN.SMS#,#BEGINN#,#DAUER#,#ENDE.SMS#,#ENDE#,#BOOKING_LINK#"
                                                                 ])
                                          :additional-buttons [:div
                                                               [mui/button {
                                                                            :variant   "contained"
                                                                            :color     "secondary"
                                                                            :startIcon (r/as-element [send])
                                                                            :onClick   #(reset! !show-send-me true)
                                                                            } "An mich per SMS"]
                                                               [mui/button {
                                                                            :style     {:marginLeft "10px"}
                                                                            :variant   "contained"
                                                                            :color     "secondary"
                                                                            :startIcon (r/as-element [send])
                                                                            :onClick   #(reset! !show-send-me-push true)
                                                                            } "An mich per Push"]]
                                          :on-cancel-fn       on-cancel-fn
                                          })]])

         ]
        ))))

(defn get-description [!actual-event !event-detail-loaded? disabled]
  (let [!state (r/atom {:show-send-me false})
        !ws-update-lock (r/cursor store/app-state [:ws-update-lock])
        !actual-user (r/cursor store/app-state [:actual-user])
        !show-send-me-email (r/cursor !state [:show-send-me])
        !su-edit (r/cursor !state [:su-edit])]
    (fn []
      (let [has-edit-right false
            save-fn (fn [text]
                      (d-events/>event-save (:crowdtaskerEvent-uuid @!actual-event) {:crowdtaskerEvent-description text}
                                            (fn [data]
                                              (reset! !su-edit false)
                                              (reset! !event-detail-loaded? false))))
            on-cancel-fn #(reset! !su-edit false)]
        [:div
         [are-you-sure-modal/are-you-sure-modal !show-send-me-email
          "Möchtest du dieses Einsatzbeschreibung Email testweise an dich senden ?" "Senden"
          (fn [] (d-events/>event-send-test-description (:crowdtaskerEvent-uuid @!actual-event) (:tom-id @!actual-user)))]
         (if (and disabled (not @!su-edit))

           [mui/card {:style {:padding "20px"}}
            [:h3 "Einsatzbeschreibung vor Annahme"]
            [:div {:dangerouslySetInnerHTML {:__html (.render md (or (get @!actual-event :crowdtaskerEvent-description) ""))}
                   :className               "editor-preview-widget"
                   :style                   {:width "45%" :marginLeft "5%" :marginBottom "5px" :display "inline-block" :vertical-align "top" :textAlign "left" :minHeight "400px" :padding "10px" :border "1px dotted grey"}}]
            [:br]
            (when (and disabled)
              [mui/button {
                           :variant   "outlined"
                           :style     {:color "orange"}
                           :startIcon (r/as-element [edit])
                           :onClick   #(reset! !su-edit true)
                           } "Bearbeiten (superuser)"])
            [mui/button {
                         :variant   "contained"
                         :style     {:marginLeft "20px"}
                         :color     "secondary"
                         :startIcon (r/as-element [send])
                         :onClick   #(reset! !show-send-me-email true)
                         } "An mich senden"]
            ]

           [(edit-md-card/get-it (get @!actual-event :crowdtaskerEvent-description) save-fn (str backend/BASE_URL "/media-upload")
                                 {:title             "Einsatzbeschreibung vor Annahme"
                                  :subText           "Textblöcke: #TOMID#,#VORNAME#,#NACHNAME#,#PREMAIL#,#PRHDY#,#PRHDY0#,#DIENSTSTELLE#, #ESTYP#,#KURZ#,#EVKURZ#,#ORT#,#BEGINN.SMS#,#BEGINN#,#DAUER#,#ENDE.SMS#,#ENDE#,#BOOKING_LINK#"
                                  :template-group    "event"
                                  :additional-button [mui/button {
                                                                  :variant   "contained"
                                                                  :color     "secondary"
                                                                  :style     {:marginLeft "20px"}
                                                                  :startIcon (r/as-element [send])
                                                                  :onClick   #(reset! !show-send-me-email true)
                                                                  } "An mich senden"]

                                  :on-cancel-fn      on-cancel-fn
                                  :lock-fn           (fn [b] (reset! !ws-update-lock b))
                                  })]
           )]
        ))))

(defn get-briefing [!actual-event !event-detail-loaded? disabled]
  (let [!state (r/atom {:show-send-me false})
        !ws-update-lock (r/cursor store/app-state [:ws-update-lock])
        !actual-user (r/cursor store/app-state [:actual-user])
        !show-send-me-email (r/cursor !state [:show-send-me])
        !su-edit (r/cursor !state [:su-edit])]
    (fn []
      (let [has-edit-right false
            save-fn (fn [text]
                      (d-events/>event-save (:crowdtaskerEvent-uuid @!actual-event) {:crowdtaskerEvent-briefing text}
                                            (fn [data]
                                              (reset! !su-edit false)
                                              (reset! !event-detail-loaded? false))))
            on-cancel-fn #(reset! !su-edit false)]
        [:div
         [are-you-sure-modal/are-you-sure-modal !show-send-me-email
          "Möchtest du dieses Einsatzbeschreibung Email testweise an dich senden ?" "Senden"
          (fn [] (d-events/>event-send-test-briefing (:crowdtaskerEvent-uuid @!actual-event) (:tom-id @!actual-user)))]
         (if (and disabled (not @!su-edit))

           [mui/card {:style {:padding "20px"}}
            [:h3 "Einsatzbeschreibung nach Annahme (wird auch per Email gesendet)"]
            [:div {:dangerouslySetInnerHTML {:__html (.render md (or (get @!actual-event :crowdtaskerEvent-briefing) ""))}
                   :className               "editor-preview-widget"
                   :style                   {:width "45%" :marginLeft "5%" :marginBottom "5px" :display "inline-block" :vertical-align "top" :textAlign "left" :minHeight "400px" :padding "10px" :border "1px dotted grey"}}]
            [:br]
            (when (and disabled)
              [mui/button {
                           :variant   "outlined"
                           :style     {:color "orange"}
                           :startIcon (r/as-element [edit])
                           :onClick   #(reset! !su-edit true)
                           } "Bearbeiten (superuser)"])
            [mui/button {
                         :variant   "contained"
                         :style     {:marginLeft "20px"}
                         :color     "secondary"
                         :startIcon (r/as-element [send])
                         :onClick   #(reset! !show-send-me-email true)
                         } "An mich senden"]
            ]

           [(edit-md-card/get-it (get @!actual-event :crowdtaskerEvent-briefing) save-fn (str backend/BASE_URL "/media-upload")
                                 {:title             "Einsatzbeschreibung nach Annahme (wird auch per Email gesendet)"
                                  :subText           "Textblöcke: #TOMID#,#VORNAME#,#NACHNAME#,#PREMAIL#,#PRHDY#,#PRHDY0#,#DIENSTSTELLE#, #ESTYP#,#KURZ#,#EVKURZ#,#ORT#,#BEGINN.SMS#,#BEGINN#,#DAUER#,#ENDE.SMS#,#ENDE#,#BOOKING_LINK#"
                                  :template-group    "event"
                                  :additional-button [mui/button {
                                                                  :variant   "contained"
                                                                  :color     "secondary"
                                                                  :style     {:marginLeft "20px"}
                                                                  :startIcon (r/as-element [send])
                                                                  :onClick   #(reset! !show-send-me-email true)
                                                                  } "An mich senden"]

                                  :on-cancel-fn      on-cancel-fn
                                  :lock-fn           (fn [b] (reset! !ws-update-lock b))
                                  })]
           )]
        ))))


(defn get-consent [!actual-event !event-detail-loaded? disabled]
  (let [!state (r/atom {:show-send-me false})
        !su-edit (r/cursor !state [:su-edit])]
    (fn []
      (let [save-fn (fn [text]
                      (println "save consent" text)
                      (d-events/>event-save (:crowdtaskerEvent-uuid @!actual-event) {:crowdtaskerEvent-consentForm text}
                                            (fn [data]
                                              (reset! !su-edit false)
                                              (reset! !event-detail-loaded? false))))
            on-cancel-fn #(reset! !su-edit false)]
        [:div
         (if (and disabled (not @!su-edit))

           [mui/card {:style {:padding "20px"}}
            [:h3 "Einsatz Selbsterklärung"]
            [:div {:dangerouslySetInnerHTML {:__html (.render md (or (get @!actual-event :crowdtaskerEvent-consentForm) ""))}
                   :className               "editor-preview-widget"
                   :style                   {:width "45%" :marginLeft "5%" :marginBottom "5px" :display "inline-block" :vertical-align "top" :textAlign "left" :minHeight "400px" :padding "10px" :border "1px dotted grey"}}]
            [:br]
            (when (and disabled)
              [mui/button {
                           :variant   "outlined"
                           :style     {:color "orange"}
                           :startIcon (r/as-element [edit])
                           :onClick   #(reset! !su-edit true)
                           } "Bearbeiten (superuser)"])
            ]

           [(edit-md-card/get-it (get @!actual-event :crowdtaskerEvent-consentForm) save-fn (str backend/BASE_URL "/media-upload")
                                 {:title             "Einsatz Selbsterklärung"
                                  :subText           "Textblöcke: #TOMID#,#VORNAME#,#NACHNAME#,#PREMAIL#,#PRHDY#,#PRHDY0#,#DIENSTSTELLE#, #ESTYP#,#KURZ#,#EVKURZ#,#ORT#,#BEGINN.SMS#,#BEGINN#,#DAUER#,#ENDE.SMS#,#ENDE#,#BOOKING_LINK#"
                                  :template-group    "event"
                                  :on-cancel-fn      on-cancel-fn
                                  })]
           )]
        ))))





(defn get-it [!actual-event !event-detail-loaded? disabled]
  (let [!create-modal (r/cursor store/app-state [:event-slot-create-modal])]
    [mui/card-content {}
     [create-with-name-modal/modal
      !create-modal
      "Bitte gib einen Namen für den neuen Termin ein"
      "Erstellen"
      (fn [name] (d-events/>new-event-slot (:crowdtaskerEvent-uuid @!actual-event) name (fn [] (reset! !event-detail-loaded? false))))
      ]
     [mui/card-content {}
      [(get-base !actual-event !event-detail-loaded? disabled)]
      [:br]
      [(get-description !actual-event !event-detail-loaded? disabled)]
      [:br]
      [(get-briefing !actual-event !event-detail-loaded? disabled)]
      [:br]
      [(get-consent !actual-event !event-detail-loaded? disabled)]
      ;[(get-explanation !actual-event !event-detail-loaded? disabled)]
      [:br]
      [(get-alarmMessage !actual-event !event-detail-loaded? disabled)]
      ]]))